var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 0,1.0014045 V 11.361405 c 0,0.79 0.87,1.27 1.54,0.84 L 9.68,7.0214045 c 0.62,-0.39 0.62,-1.29 0,-1.69 L 1.54,0.16140453 c -0.67,-0.43 -1.54,0.05 -1.54,0.83999997 z","id":"path2"}));
}

Play.defaultProps = {"width":"100%","viewBox":"0 0 10.145 12"};

module.exports = Play;

Play.default = Play;
